import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { ConfirmProvider } from './context/ConfirmContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Devices from './pages/Devices';
import SensorDetail from './pages/SensorDetail';
import Map from './pages/Map';
import Alarms from './pages/Alarms';
import Control from './pages/Control';
import Users from './pages/Users';
import Companies from './pages/Companies';
import Regions from './pages/Regions';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import './App.css';
import './styles/Login.css';

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <ConfirmProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors closeButton theme="dark" />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/devices" element={<ProtectedRoute><Devices /></ProtectedRoute>} />
              <Route path="/sensors/:id" element={<ProtectedRoute><SensorDetail /></ProtectedRoute>} />
              <Route path="/map" element={<ProtectedRoute><Map /></ProtectedRoute>} />
              <Route path="/alarms" element={<ProtectedRoute><Alarms /></ProtectedRoute>} />
              <Route path="/control" element={<ProtectedRoute requiredRoles={['SUPERADMIN','AVUK','KRYEINSPEKTORI']}><Control /></ProtectedRoute>} />
              <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
              <Route path="/companies" element={<ProtectedRoute requiredRoles={['SUPERADMIN','AVUK']}><Companies /></ProtectedRoute>} />
              <Route path="/users" element={<ProtectedRoute requiredRoles={['SUPERADMIN','AVUK','KRYEINSPEKTORI']}><Users /></ProtectedRoute>} />
              <Route path="/regions" element={<ProtectedRoute requiredRoles={['SUPERADMIN','AVUK']}><Regions /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </BrowserRouter>
        </ConfirmProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
